module.exports = __webpack_public_path__ + "img/sttrumoc.1a352036.png";